import { Transition } from "@headlessui/react";

export default function FadeTransition({
	show,
	delayIn = "0",
	delayOut = "0",
	children,
}) {
	return (
		<Transition
			show={show}
			enter={`transition-opacity duration-300 delay-${delayIn}`}
			enterFrom="opacity-0"
			enterTo="opacity-100"
			leave={`transition-opacity duration-150 delay-${delayOut}`}
			leaveFrom="opacity-100"
			leaveTo="opacity-0"
		>
			{children}
		</Transition>
	);
}
